<template>
    <div style="display: inline-block;" :class="className">
        <span @click.stop="visible=true">
            <slot></slot>
        </span>
        <el-dialog
            :visible.sync="visible"
            :append-to-body="true"
            :custom-class="'dialogAddress'"
            :title="this.type === 3? '预约安装':`${this.type === 1? '修改': '添加'}收货地址`"
            style="width: 1000px"
        >
            <el-form ref="form" :rules="rules" :model="formData" label-width="120px">
                <el-form-item label="姓名：" prop="consignee">
                    <el-input v-model="formData.consignee"></el-input>
                </el-form-item>
                <el-form-item label="电话：" prop="mobile">
                    <el-input v-model="formData.mobile"></el-input>
                </el-form-item>
                <el-form-item label="备用电话：" prop="tel">
                    <el-input v-model="formData.tel"></el-input>
                </el-form-item>
                <el-form-item >
                    <slot name="orderSelect"></slot>
                </el-form-item>
                <el-form-item class="address" label="地址：">
                    <el-select v-model="formData.province" placeholder="省份">
                        <el-option
                            v-for="{region_id, region_name} in provinceList"
                            :key="region_id"
                            :value="region_id"
                            :label="region_name"
                        >
                        </el-option>
                    </el-select>
                    <el-select v-model="formData.city" placeholder="城市">
                        <el-option
                            v-for="{region_id, region_name} in cityList"
                            :key="region_id"
                            :value="region_id"
                            :label="region_name"
                        ></el-option>
                    </el-select>
                    <el-select v-model="formData.district" placeholder="区">
                        <el-option
                            v-for="{region_id, region_name} in districtList"
                            :key="region_id"
                            :value="region_id"
                            :label="region_name"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="address">
                    <el-input :rows="3" type="textarea" placeholder="详细地址信息" v-model="formData.address"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="changeAddr" :loading="btnLoading">确定
                    </el-button>
                    <el-button @click="quxiao">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import { getAddressSelect, changeAddress, postAppointment, ChangeOrderMsg } from '../../stores/api';
    import { mapState } from 'vuex';

    export default {
        props: ['editData', 'type', 'getAddress', 'className', 'time', 'order', 'orderlt', 'delivery_method', 'getOrderList','getOrderDetail'],  //type1:修改，2：添加,3:预约，4修改订单地址
        data () {
            return {
                btnLoading: false,
                visible: false,
                formData: {
                    ...(this.editData || {
                        consignee: '',
                        mobile: '',
                        province: '',
                        city: '',
                        district: '',
                        address: '',
                    })
                },
                cityList: [],
                districtList: [],
                //dialog校验
                rules: {
                    consignee: [{required: true, message: '请输入名字', trigger: 'blur'}],
                    mobile: [{required: true, message: '请输入手机', trigger: 'blur'}],
                    address: [{required: true, message: '请输入地址', trigger: 'blur'}],
                },
                rec_ids:[],
                numbers:[],
            };
        },
        created() {
            console.log(this.order)
        },
        methods: {
//            quxiao(){
//                console.log(this.orderlt);
//                console.log(JSON.stringify(this.rec_ids))
//                console.log(JSON.stringify(this.numbers))
//                console.log(this.order.order_id);
//                console.log(this.delivery_method);
//            },
            async getCityList (id) {
                return getAddressSelect(id).then((res) => {
                    this.cityList = res.data;
                    return res.data;
                });
            },
            async getDistrictList (id) {
                return getAddressSelect(id).then(res => {
                    this.districtList = res.data;
                    return res.data;
                });
            },
            changeAddr () {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        this.btnLoading = true;
                        //预约安装
                        if (this.type === 3) {
                            await this.setAppointment();
                            this.btnLoading = false;
                            this.visible = false;
                            return;
                        }
                        //修改订单地址
                        if (this.type === 4) {
                            await this.editOrderAddress();
                            this.btnLoading = false;
                            this.visible = false;
                            return;
                        }
                        changeAddress(this.formData).then(async (res) => {
                            localStorage.setItem('address_id', res.data.address_id)
                            await this.getAddress();
                            this.$notify.success({
                                title: '操作成功',
                                message: `${this.type === 1 ? '修改' : '添加'}地址成功`,
                            });
                        }).catch((err) => {
                            this.$notify.error({
                                title: '操作失败',
                                message: err.message,
                            });
                        }).then(() => {
                            this.btnLoading = false;
                            this.visible = false;
                            //添加完后清空信息
                            if (this.type === 2) {
                                Object.assign(this.formData, {
                                    consignee: '',
                                    mobile: '',
                                    address: ''
                                });
                            }
                        });
                    }
                });
            },
            //预约安装
            async setAppointment () {
                this.rec_ids = []
                this.numbers = []
                this.orderlt.forEach(item => {
                    this.rec_ids.push(item.rec_id)
                    this.numbers.push(item.num)
                })
                const {district, province, city, ...rest} = this.formData;
                postAppointment({
                    city_checked_id: city,
                    district_checked_id: district,
                    province_checked_id: province,
                    order_sn: this.order.order_sn,
                    yuyue_time: this.time,
                    rec_ids: this.rec_ids,
                    numbers: this.numbers,
                    delivery_method: this.delivery_method,
                    order_id: this.order.order_id,
                    ...rest,
                }).then(() => {
                    this.$notify.success({
                        title: '操作成功',
                        message: `已预约安装`,
                    });
                    // this.order.is_yuyue = 1;
                    this.order.consignee = this.formData.consignee;
                    this.getOrderList({page: sessionStorage.getItem('pase')})
                }).catch(err => {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message,
                    });
                    this.btnLoading = false;
                });
            },
            //修改订单地址
            async editOrderAddress () {
                const {district, province, city, ...rest} = this.formData;
                let data = {
                    order_id: this.order.order_id,
                    'city': city,
                    'consignee': this.formData.consignee,
                    'district': district,
                    'mobile': this.formData.mobile,
                    'tel': this.formData.tel,
                    'province': province,
                    'address': this.formData.address,
                    'contract_number': this.order.contract_number,
                }
                ChangeOrderMsg(data).then(async (res) => {
                    if (res.data.error === 0) {
                        this.$notify.success({
                            title: '操作成功',
                            message: `已修改地址`,
                        });
                        this.getOrderDetail()
                        const {address, province, city, district} = this.formData;
                        const provinceStr = this.provinceList.find(p => p.region_id === province).region_name;
                        const cityStr = this.cityList.find(c => c.region_id === city).region_name;
                        const districtStr = this.districtList.find(d => d.region_id === district).region_name;
                        this.$emit('update:editData', {
                            ...this.editData,
                            ...this.formData,
                            address_str: `${provinceStr},${cityStr},${districtStr} ${address}`,
                        });
                    }
                }).catch(err => {
                    // this.$notify.error({
                    //     title: '操作失败',
                    //     message: err.message,
                    // });
                    this.btnLoading = false;
                });
            }
        },
        watch: {
            'formData.province': async function (val, oldVal) {
                const data = await this.getCityList(val);
                if (data.length > 0) {
                    this.formData.city = data[0].region_id;
                }
            },
            'formData.city': async function (val, oldVal) {
                const data = await this.getDistrictList(val);
                if (data.length > 0) {
                    this.formData.district = data[0].region_id;
                }
            },
            async visible (val) {
                if (val) {
                    if (this.type === 1||this.type===4) {
                        this.getCityList(this.formData.province);
                        this.getDistrictList(this.formData.city);
                    } else {
                        const provinces = await this.getCityList(this.provinceList[0].region_id);
                        const districts = await this.getDistrictList(provinces[0].region_id);
                        this.formData.province = this.provinceList[0].region_id;
                        this.formData.city = provinces[0].region_id;
                        this.formData.district = districts[0].region_id;
                    }
                }
            },
            editData (val) {
                if (this.type === 3) {
                    const {province_checked_id, city_checked_id, district_checked_id, ...rest} = val;
                    this.formData = {
                        province: province_checked_id,
                        city: city_checked_id,
                        district: district_checked_id,
                        ...rest
                    };
                } else {
                    this.formData = {...val};
                }
            }
        },
        computed: {
            ...mapState(['provinceList']),
        }
    };
</script>
<style lang="less">
    .dialogAddress {
        width: 1000px;
        .el-dialog__header {
            display: flex;
            justify-content: center;
            border-bottom: 1px solid #C7C7C7;
        }
        .el-dialog__body {
            padding: 30px 90px 30px 70px;
            .address > .el-form-item__content {
                display: flex;
                & > div {
                    margin-right: 8px;
                }
            }
            .el-form-item {
                margin-bottom: 22px;
                .el-form-item__label {
                    width: 90px !important;
                    font-size: 14px;
                }
                .el-form-item__content {
                    margin-left: 100px !important;
                    .el-select {
                        .el-input__inner {
                            font-size: 12px;
                            padding: 0 8px;
                        }
                    }
                }
            }
            .additional {
                .el-form-item__content {
                    margin-left: 30px !important;
                    background: #f5f5f5;
                    & > div {
                        padding: 8px 0;
                        .el-button + .el-button {
                            margin-left: 0;
                        }
                        display: flex;
                        justify-content: space-around;
                        flex-wrap: wrap;
                        button {
                            padding: 10px;
                            margin-bottom: 5px;
                            border-radius: 2px;
                            background: transparent;
                            color: #2795f5;
                            font-size: 12px;
                            border: 1px solid transparent;
                            &:hover {
                                border-color: #2795f5 !important;
                            }
                        }
                    }

                }
            }

        }
    }
</style>





// WEBPACK FOOTER //
// src/components/Common/AddressDialog.vue